/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { PureComponent } from 'react';
import UILink from 'UIComponents/link/UILink';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getUrl, getEntryUrlContext } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  message: RecordPropType('ContextUpdateMessage').isRequired
};
class EntryUrlContextUpdate extends PureComponent {
  getEntryUrlLink(entryUrl) {
    const url = getUrl(entryUrl);
    return /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: url,
      truncate: true,
      truncateStringProps: {
        matchContentWidth: true,
        useFlex: false,
        tooltip: false
      },
      use: "blue",
      children: url
    });
  }
  render() {
    const {
      message
    } = this.props;
    const entryUrl = getEntryUrlContext(message);
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.entryUrl",
      options: {
        entryUrl: this.getEntryUrlLink(entryUrl)
      }
    });
  }
}
EntryUrlContextUpdate.propTypes = propTypes;
export default EntryUrlContextUpdate;